<template>
    <section class="blockElement p-0 registrMob loginLoader">
        <div class="loginregister">
            <app-language :page="'login'"> </app-language>
        </div>
        <div class="container-fluid">
            <div class="riskWarningMsg d-md-none">
                <small>{{ $t("lg_riskWarningMsg") }}</small>
            </div>
            <div class="innerInclude p_login"> 
                <div class="row">
                    <div class="mobileLogo d-md-none">
                        <router-link :to="'/'" class="green">
                            <img src="../../../../static/fxView/images/fxview_logo.svg" alt="fxView" />
                        </router-link>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4 text-center d-flex vh_100 flex-wrap blueBG beforeBG justify-content-center align-items-center" style="background: var(--secondarycolor) !important;">
                        <div class="w-100 pt-5">
                            <!-- <div class="titleArera Loginlogo">
                                <router-link :to="'/'" class="green">
                                    <img src="../../../../static/fxView/images/fxview_logo_white.svg" alt="fxView" />
                                </router-link>
                            </div> -->
                            <div class="w-100 mt-0">
                                <img src="../../../../static/fxView/images/logreg.svg" alt="fxView" />        
                            </div>
                        </div>
                    </div>
                    <!--loader - message--->
                    <div class="col-12 col-md-6 col-xl-8 p-0 d-flex vh_100 align-items-center customHeight">
                        <div class="sign_insec">
                            <div class="subtitle">
                                <h3 class="mb-2 text-center">{{ $t("reg_openacc") }}</h3>
                                <p class="mb-4 text-center ">{{ $t("reg_takeminute") }}</p>
                                <complete-loading :pageloader_value="pageLoader" :type="'complete'"
                                    v-if="pageLoader"></complete-loading>
                                <!--<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>-->
                                <div>
                                    <div class="warningMsg mb-3 p-3" v-if="response_msg != '' && msg_type == 'error'">
                                        <div class="infomsg d-flex align-items-center justify-content-between">
                                            <div class="d-flex w-100 align-items-center">
                                                <p v-html="response_msg ">
                                                    <feather type="alert-circle"></feather>
                                                </p>
                                            </div>
                                            <feather type="x" @click.prevent="hideFunc()"></feather>
                                        </div>
                                    </div>
                                    <div class="warningMsg successMsg mb-3 p-3 fdgfd"
                                        v-if="response_msg != '' && msg_type == 'success'">
                                        <div class="infomsg d-flex align-items-center justify-content-between">
                                            <div class="d-flex w-100 align-items-center" >
                                                <p v-html="response_msg">
                                                    <feather type="check"></feather>
                                                </p>
                                            </div>
                                            <feather type="x" @click.prevent="hideFunc()"></feather>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="stepForm"> 
                                <!-- <div class="form-group field-wrapper tabClass"  >
                                    <v-select :clearable="false" :options="accountType" :reduce="name => name.id" label="name" v-model="account_type"  v-validate="'required'" name="account_type"  :class="(( account_type != '')?'active' :'') || ({ 'is-invalid': submitted && errors.has('account_type') })" class="customflaotField form-control"  />
                                    <label for="username" class="float-label">{{$t('reg_selectacctype')}}</label>
                                    <p class="error" v-for="error in errors.collect('account_type')">{{ error }}</p>
                                </div> -->
                                <!-- <div class="form-group field-wrapper">
                                    <input
                                        placeholder=" "
                                        type="text"
                                        name="fname"
                                        v-model="fname"
                                        class="float-field form-control"
                                        v-validate="required"
                                        :class="{ 'is-invalid': submitted && errors.has('fname') }"
                                        ref="fname"
                                    />
                                    <label for="username" class="float-label">{{ $t("reg_Enterfname") }}</label>
                                    <p class="error" v-for="error in errors.collect('fname')">
                                        {{ error }}
                                    </p>
                                </div>
                                <div class="form-group field-wrapper">
                                    <input
                                        placeholder=" "
                                        type="text"
                                        name="lname"
                                        v-model="lname"
                                        class="float-field form-control"
                                        :class="{ 'is-invalid': submitted && errors.has('fname') }"
                                        ref="lname"
                                    />
                                    <label for="username" class="float-label">{{ $t("reg_Enterlname") }}</label>
                                    <p class="error" v-for="error in errors.collect('fname')">
                                        {{ error }}
                                    </p>
                                </div> -->
                                <div class="form-group field-wrapper tabClass" @click.prevent="tabActiveFun('2')">
                                    <v-select :clearable="false" :options="residence_country"
                                        :reduce="(name) => name.iso2" label="name" v-model="res_country"
                                        v-validate="'required'" name="residence country"
                                        :class="(tabActive == '2' || res_country != '' ? 'active' : '') || { 'is-invalid': submitted && errors.has('residence country') }"
                                        class="customflaotField form-control" ref="residence country"/>
                                    <label for="username" class="float-label">{{ $t("reg_selectcountry") }}</label>
                                    <p class="error" v-for="error in errors.collect('residence country')">
                                        {{ error }}
                                    </p>
                                </div>
                                <div class="form-group field-wrapper">
                                    <input placeholder=" " type="text" name="name" v-model="username"
                                        class="float-field form-control" v-validate="'required|no_special_characters'"
                                        :class="{ 'is-invalid': submitted && errors.has('name') }" ref="name" @focus="trackEvent('username')" />
                                    <label for="username" class="float-label">{{ $t("reg_Entername") }} {{$t('fxPerID')}}</label>
                                    <p class="error" v-for="error in errors.collect('name')">
                                        {{ error }}
                                    </p>
                                </div>
                                <div class="form-group field-wrapper">
                                    <input placeholder=" " type="text" name="email" v-model="email"
                                        class="float-field form-control" v-validate="'required|email'"
                                        :class="{ 'is-invalid': submitted && errors.has('email') }" ref="emailInput"
                                        autocomplete="undefined" @focus="trackEvent('email')"/>
                                    <label for="username" class="float-label">{{ $t("reg_Enteremail") }}</label>
                                    <p class="error" v-for="error in errors.collect('email')">
                                        {{ error }}
                                    </p>
                                </div>
                                <div class="form-group field-wrapper phone-wrapper"> 
                                    <vue-phone-number-input 
                                        v-model="mobile_number"  
                                        :no-example="true" 
                                        :default-country-code="getCountryCode()" 
                                        v-validate="{ required: true, min:5, max:15 }" 
                                        ref="mobile_numberInput" 
                                        class="float-field form-control"
                                        :class="{ 'is-invalid': submitted && errors.has('mobile_number') }" 
                                        name="mobile_number" 
                                        @update="updatedText"
                                    />
                                    <p class="error mb-2" v-if="submitted" v-for="error in errors.collect('mobile_number')">{{$t('InvalidNumber')}}</p>  
                                </div> 
                                <div class="clearfix"></div>
                                <div class="form-group field-wrapper">
                                    <input placeholder=" " :type="inputtype" name="password" v-model="password"
                                        class="float-field form-control"
                                        v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/])(?=.*[!@#$%^&*])\S{6,24}$/, }"
                                        :class="{ 'is-invalid': submitted && errors.has('password'), }"
                                        ref="passwordInput" autocomplete="undefined" @focus="trackEvent('password')" />
                                    <label for="username" class="float-label">{{ $t("reg_Enterpwd") }}</label>
                                    <feather :type="iconType" class="toggle-password"
                                        @click.prevent="switchVisibility"></feather>
                                    <!--<div v-if="!submitted && passwordErr" class="error"> {{$t('passCharVal')}} </div>-->
                                    <p class="error" v-for="error in errors.collect('password')">
                                        <span v-show="error == 'The password field is required.'">{{
                                            $t("reg_passwordFieldReq") }}</span>
                                        <span v-show="error == 'The password field format is invalid.'">{{
                                            $t("reg_passCharVal") }}</span>
                                    </p>
                                </div>
                                <div class="form-group field-wrapper m-0 d-flex align-items-center justify-content-between" >
                                    <div class="capticha" >
                                        <vue-recaptcha class="captchaRegister" sitekey="6LcivBArAAAAADQ5sZSOf-5bbKHlE0pmqDxDt-ax" ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" size="visible"></vue-recaptcha>
                                        
                                        <p class="error">
                                            <span v-if="captachErr">{{ $t("reg_captchaErr") }}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <!--  <div class="orSignUp text-center mt-3 mb-2">
                                    <strong class="position-relative">OR Sign Up With</strong>
                                </div> -->
                                <!--   <div class="d-flex align-items-center justify-content-between otherLoginOption">
                                    <a href="#" class="google_btn btn_sm"><img width="15" src="../../../../static/fxView/images/googleIco.svg" alt="Icon">Google </a>
                                    <a href="#" class="facebook_btn btn_sm"><img width="15" src="../../../../static/fxView/images/facebookIco.svg" alt="Icon">Facebook </a>
                                </div> -->
                                <!-- <div class="w-100 d-flex align-items-center justify-content-center justify-content-md-start mb-3">
                                    <p class="mb-0">{{ $t("reg_signagree") }}<a :href="$env_var.privacyPolicyLinkNew"
                                            target="_blank">{{ $t("reg_privacyPolicy") }}.</a></p>
                                </div> -->
                                <div class="w-100 d-flex align-items-center justify-content-center mb-2 pt-3">
                                    <p class="mb-0 policyText">{{ $t("reg_signagree") }}<a :href="$env_var.privacyPolicyLinkNew"
                                            target="_blank">{{ $t("reg_privacyPolicy") }}.</a></p>
                                </div>
                                <div class="d-flex justify-content-between align-items-strech register-bts-row flex-column">
                                    <div class="submitButton mt-0">
                                        <button class="prism_btn w-100 submitBtn" v-on:click.prevent="create_new_lead()">
                                            {{ $t("reg_register") }}
                                        </button>
                                    </div>
                                    <div class="btoomSave">
                                        <div class="forgot_sec d-flex align-items-center justify-content-center pt-2">
                                            <h4 class="mb-0 regular textColor">
                                                {{ $t("reg_haveAccount") }}
                                                <router-link @click.native="loginEvent" :to="'/'" class="">{{ $t("reg_login") }}</router-link>
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center align-items-center my-2">
                                    <div class="modal-popup LoginPopup"
                                        v-if="res_country != '' && res_country != null && res_country != undefined && european_countries_list.hasOwnProperty(res_country)">
                                        <div class="middleBox p-3 whiteBG">
                                            <p class="text-center" style="font-size: 14px;">
                                                {{ $t("chEn_redirectmsg1") }} {{ $t("chEn_redirectmsg2") }}
                                            </p>
                                            <div
                                                class="w-100 d-flex justify-content-center align-items-center mt-4 mb-3">
                                                <a href="https://app.fxview.com/register"
                                                    class="prism_btn btn_sm mr-3">{{
                                                    $t("chEn_continue") }}</a>
                                                <a href="#" @click="res_country = ''" class="prism_btn btn_sm darkBG">{{
                                                    $t("chEn_takeback") }}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <change-entity
                                        v-if="$env_var.european_countries_list.hasOwnProperty(res_country)"></change-entity>
                                </div>

                                <div class="charlgateMsg border-top pt-2 mt-3 text-center">
                                    <small>{{ $t('fxFooterContent') }}</small>
                                    <!--  <small v-else>{{$t('lg_charlgateMsEurope')}}</small> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-12 col-md-6 col-xl-8 p-0 text-center d-flex vh_100 align-items-center">
                        <div class="sign_insec">
                            <div class="subtitle text-center">
                                <complete-loading :pageloader_value="pageLoader" :type="'complete'"
                                    v-if="pageLoader"></complete-loading>
                                <message-component :message="response_msg" :messageType="msg_type"
                                    v-if="response_msg != ''"></message-component>
                            </div>
                            <div class="stepForm">
                                <div class="otpBlock">
                                    <img width="80" class="mb-3" src="../../../../static/fxView/images/email.svg" />
                                    <p class="mb-3">{{ $t("reg_registerMsz2") }}</p>
                                    <div class="form-group field-wrapper">
                                        <input placeholder=" " type="text" maxlength="6" v-model="otp" name="otp"
                                            class="float-field form-control"
                                            :class="{ 'is-invalid': submittedOtp && errors.has('otp'), }"
                                            v-validate="{ required: true, max: 6, numeric: true }" ref="otpInput" @focus="trackEvent('otp')" />
                                        <label for="pannumber" class="float-label">{{ $t("reg_enterOtp") }} </label>

                                        <p class="error" v-for="error in errors.collect('otp')">
                                            {{ error }}
                                        </p>
                                    </div>
                                    <div class="signupbtn submitButton">
                                        <button class="prism_btn btn_sm mb-3" v-on:click.prevent="verify_lead()">
                                            {{ $t("reg_submit") }}
                                        </button>
                                        <div class="forgot_sec">
                                            <a href="#" class="tpArea underline" v-on:click.stop.prevent="resend()">{{
                                                $t("reg_resendotp") }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <!-- <div class="fixedBarBottom fullwidth register-page-fixedbar">
            <div class="footPromoLastBar  text-center">
                <p class="" v-html="$t('footerMsz2')"></p>
                <a href="https://fxview.com/static/fxview/pdf/legal-document/Risk-Disclosure-And-Warnings-Notice.pdf" target="_blank">{{$t('riskDisclaimer')}}</a> 
            </div>
        </div> -->
    </section>
</template>

<script>
    const crypto = require("crypto");
    import * as types from "@/types";
    import { mapActions } from "vuex";
    import language from "../shared/language_before_login";
    import { fxViewMixins } from "@/plugins/fxView";
    import { handleButtonClick } from '../../../../tracker.js'
    import VueRecaptcha from "vue-recaptcha";

    export default {
        name: "Register",
        mixins: [fxViewMixins],
        data() {
            return {
                current_language: navigator.language.split("-")[0],
                residence_country: [],
                res_country: "",
                account_type: "0",
                accountType: [
                    { id: "0", name: "Individual" },
                    { id: "1", name: "Joint" },
                    { id: "2", name: "Corporate" },
                ],
                // insertId: "-1",
                username: "",
                lname: "",
                fname: "",
                email: "",
                username: "",
                password: "",
                confirm_password: "",
                mobile_number: "",
                otp: "",
                error_msg_password: "",
                submitted: false,
                submittedOtp: false,
                inputtype: "password",
                showpassword: false,
                iconType: "eye-off",
                userCountry: "N/A",
                pageLoader: false,
                response_msg: "",
                msg_type: "",
                passwordErr: false,
                numberValid: true,
                numberWithCountry: "",
                captchaVerified: false,
                captchaToken: "",
                captachErr: false,
                IBREFERLINK: "",
                tabActive: "",
                admin_id: "0",
                rm_id: "0",
                inputtype2: "password",
                showpassword2: false,
                iconType2: "eye-off",
                firstSourceUrl: '',
                secondSourceUrl: '',
                prevUrl: null
            };
        },
        watch: {
            response_msg(newValue){
                if(newValue !== '' && this.msg_type === 'error'){
                    this.$trackEvent('FXView+Register+Email+Exist');
                }
            }
            
        },
        components: {
            appLanguage: language,
            VueRecaptcha,
        },
        methods: {
            tabActiveFun(getData) {
                this.tabActive = getData;
            },
            hideFunc() {
                this.response_msg = "";
                this.msg_type = "";
            },
            getCountryCode() {
                let country = "";
                if (this.res_country) {
                    country = this.res_country;
                } else if (this.userCountry !== "N/A") {
                    country = this.userCountry;
                }
                return country;
            },
            switchVisibility() {
                this.showpassword = !this.showpassword;
                if (this.showpassword) {
                    this.inputtype = "text";
                    this.iconType = "eye";
                } else {
                    this.inputtype = "password";
                    this.iconType = "eye-off";
                }
            },
            switchVisibility1() {
                this.showpassword2 = !this.showpassword2;
                if (this.showpassword2) {
                    this.inputtype2 = "text";
                    this.iconType2 = "eye";
                } else {
                    this.inputtype2 = "password";
                    this.iconType2 = "eye-off";
                }
            },

            ...mapActions({
                _runUserSignUp: types.RUN_USER_SIGNUP,
                _runVerifyLeadOtp: types.RUN_VERIFY_LEAD_OTP,
                _runGetUserIp: types.RUN_GET_USER_IP,
            }),

            onCaptchaVerified: function (recaptchaToken) {
                
                const self = this;
                if(recaptchaToken) {
                    this.captchaVerified = true;
                }
                this.captchaToken = recaptchaToken;
                // self.$refs.recaptcha.reset();
              },
              onCaptchaExpired: function () {
                this.$refs.recaptcha.reset();
              },
            // resend() {
            //     this.$trackEvent('FXView+OTP+Resend')
            //     const mykey = crypto.createCipher("aes-128-cbc", "F*V(I)e^E#1108@3");
            //     let hashedstr = mykey.update(this.password, "utf8", "hex");
            //     hashedstr += mykey.final("hex");
            //     let firstname = this.username.split(" ")[0];
            //     let lastname = this.username.replace(firstname, "").trim();
            //     let input_json = {
            //         globalParams: {
            //             // username : _that.username,
            //             fname: firstname,
            //             lname: lastname,
            //             email: this.email,
            //             account_type: this.account_type,
            //             mobile: this.numberWithCountry,
            //             admin_id: this.admin_id,
            //             rm_id: this.rm_id,
            //             password: hashedstr,
            //             // captchaToken: this.captchaToken,
            //             IBREFERLINK: this.IBREFERLINK,
            //             residence_country: this.res_country,
            //         },
            //         localParams: { parameter: this, page: "resend" },
            //     };
            //     if (this.$cookies.get("refLink") && this.$cookies.get("refRm")) {
            //         input_json.globalParams.rm_id = this.$cookies.get("refRm");
            //         input_json.globalParams.admin_id = this.$cookies.get("refLink");
            //     } else if (this.$cookies.get("IBREFERLINK")) {
            //         let decrpyLinRm = window.atob(this.$cookies.get("IBREFERLINK").toString());
            //         let decrpyLinRm1 = decrpyLinRm.split("||");
            //         this.$cookies.set("refLink", window.btoa(decrpyLinRm1[0]), "4y", null, this.$env_var.cookieSaveUrl);
            //         this.$cookies.set("refRm", window.btoa(decrpyLinRm1[1]), "4y", null, this.$env_var.cookieSaveUrl);
            //         input_json.globalParams.rm_id = this.$cookies.get("refRm");
            //         input_json.globalParams.admin_id = this.$cookies.get("refLink");
            //     }
            //     this._runUserSignUp(input_json);
            // },
            updatedText(e) {
                this.numberWithCountry = e.formattedNumber;
                this.numberValid = e.isValid;
            },
            create_new_lead() {
                const _that = this;
                this.create_lead();
            },
            create_lead() {
                const _that = this;
                _that.submitted = true;
                const mykey = crypto.createCipher("aes-128-cbc", "F*V(I)e^E#1108@3");
                let hashedstr = mykey.update(_that.password, "utf8", "hex");
                hashedstr += mykey.final("hex");
                _that.$validator.validate().then((valid) => {
                    if (valid) {
                        let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/])(?=.*[!@#$%^&*])\S{6,24}$/;
                        if (!regex.test(_that.password)) {
                            _that.passwordErr = true;
                            _that.submitted = false;
                        } 
                        // else if (!this.captchaVerified) {
                        //     _that.captachErr = true;
                        //     _that.submitted = false;
                        // } 
                        else {
                            _that.passwordErr = false;
                            _that.submitted = false;
                            let firstname = _that.username.split(" ")[0];
                            let lastname = _that.username.replace(firstname, "").trim();
                            let input_json = {
                                globalParams: {
                                    // username : _that.username,
                                    fname: firstname,
                                    lname: lastname,
                                    email: _that.email,
                                    account_type: _that.account_type,
                                    mobile: _that.numberWithCountry,
                                    admin_id: _that.admin_id,
                                    rm_id: _that.rm_id,
                                    password: hashedstr,
                                    captchaToken: this.captchaToken,
                                    residence_country: _that.res_country,
                                    IBREFERLINK: _that.IBREFERLINK,
                                    ip_country: this.userCountry,
                                    source_first: _that.prevUrl,
                                    source_second: window.location.href,
                                },
                                localParams: { parameter: _that },
                            };

                            //===========in use==============
                            if (_that.$cookies.get("investing_ref")) {
                                input_json.globalParams.investing_ref = _that.$cookies.get("investing_ref");
                            }
                            if (_that.$cookies.get("refLink") && _that.$cookies.get("refRm")) {
                                input_json.globalParams.rm_id = _that.$cookies.get("refRm");
                                input_json.globalParams.admin_id = _that.$cookies.get("refLink");
                            } else if (_that.$cookies.get("IBREFERLINK")) {
                                let decrpyLinRm = window.atob(_that.$cookies.get("IBREFERLINK").toString());
                                let decrpyLinRm1 = decrpyLinRm.split("||");
                                _that.$cookies.set("refLink", window.btoa(decrpyLinRm1[0]), "4y", null, _that.$env_var.cookieSaveUrl);
                                _that.$cookies.set("refRm", window.btoa(decrpyLinRm1[1]), "4y", null, _that.$env_var.cookieSaveUrl);
                                input_json.globalParams.rm_id = _that.$cookies.get("refRm");
                                input_json.globalParams.admin_id = _that.$cookies.get("refLink");
                            }
                            this.$trackEvent('FXView+Register+Submit');
                            _that._runUserSignUp(input_json).then((response) => {
                                let apiResp = response.res_data.user.profile
                                handleButtonClick(apiResp.user_id)
                            })
                            _that.$refs.recaptcha.reset();
                        }
                    } else {
                        _that.handleValidationErrorAdvanced(_that.errors);
                    }
                });
            },
            // verify_lead() {
            //     this.$trackEvent('FXView+OTP+Submit');
            //     const _that = this;
            //     _that.submittedOtp = true;
            //     const mykey = crypto.createCipher("aes-128-cbc", "F*V(I)e^E#1108@3");
            //     let hashedstr = mykey.update(_that.password, "utf8", "hex");
            //     hashedstr += mykey.final("hex");
            //     _that.$validator.validate().then((valid) => {
            //         if (valid) {
            //             let input_json = {
            //                 globalParams: {
            //                     browser_language: this.current_language,
            //                     email: _that.email,
            //                     account_type: _that.account_type,
            //                     mobile: _that.numberWithCountry,
            //                     password: hashedstr,
            //                     OTP: _that.otp,
            //                     // ID: _that.insertId,
            //                     IBREFERLINK: _that.IBREFERLINK,
            //                     ip_country: this.userCountry,
            //                 },
            //                 localParams: { parameter: _that },
            //             };
            //             //==not in use===============
            //             if (_that.$cookies.get("referralId")) {
            //                 input_json.globalParams.referralId = _that.$cookies.get("referralId");
            //             }
            //             if (_that.$cookies.get("investing_ref")) {
            //                 input_json.globalParams.investing_ref = _that.$cookies.get("investing_ref");
            //             }
            //             //===========in use==============
            //             if (_that.$cookies.get("refLink") && _that.$cookies.get("refRm")) {
            //                 input_json.globalParams.refLink = _that.$cookies.get("refLink");
            //                 input_json.globalParams.refRm = _that.$cookies.get("refRm");
            //             } else if (_that.$cookies.get("IBREFERLINK")) {
            //                 let decrpyLinRm = window.atob(_that.$cookies.get("IBREFERLINK").toString());
            //                 let decrpyLinRm1 = decrpyLinRm.split("||");
            //                 _that.$cookies.set("refLink", window.btoa(decrpyLinRm1[0]), "4y", null, _that.$env_var.cookieSaveUrl);
            //                 _that.$cookies.set("refRm", window.btoa(decrpyLinRm1[1]), "4y", null, _that.$env_var.cookieSaveUrl);
            //                 input_json.globalParams.refLink = _that.$cookies.get("refLink");
            //                 input_json.globalParams.refRm = _that.$cookies.get("refRm");
            //             }
            //             // try {
            //             //     __adroll.track("pageView", { segment_name: "4cfb31ed" });
            //             // } catch (err) {}
            //             _that._runVerifyLeadOtp(input_json);
            //         } else {
            //             _that.handleValidationErrorAdvanced(_that.errors);
            //         }
            //     });
            // },
            RemoveNode(iso2) {
                return this.countriesList.filter(function (emp) {
                    if (emp.iso2 == iso2) {
                        return false;
                    }
                    return true;
                });
            },
            countryCookisGet() {
                if (this.$cookies.get("countrySelectedFromWebsite") != undefined) {
                    if (this.$cookies.get("countrySelectedFromWebsite") == "IN") {
                        // this.response_msg = 'you are not allowed to register in this portal'
                        // this.msg_type = 'error'
                    } else {
                        this.res_country = this.$cookies.get("countrySelectedFromWebsite");
                    }
                }
            },
            // runVerify() {
            //     const encyptKey = this.$route.query["verify"];
            //     let mykey = crypto.createDecipher("aes-128-cbc", "F*V(I)e^E#1108@3");
            //     let mystr = mykey.update(encyptKey, "hex", "utf8");
            //     mystr += mykey.final("utf8");
            //     let infoArray = mystr.split("^");
            //     if (this.IBREFERLINK == "") {
            //         this.IBREFERLINK = infoArray[5];
            //     }
            //     let input_json = {
            //         globalParams: {
            //             verify: this.$route.query["verify"],
            //             ip_country: this.userCountry,
            //         },
            //         localParams: { parameter: this },
            //     };
            //     this._runVerifyLeadOtp(input_json);
            //     console.log("tag input_json", input_json);
            // },
            setCritio(country) {
                this.userCountry = country;
                let p_countries = {
                    AE: 104607,
                    AR: 104608,
                    AU: 103314,
                    BR: 104609,
                    CA: 104610,
                    DE: 103065,
                    DK: 103066,
                    ES: 103313,
                    IT: 104611,
                    KE: 104612,
                    MA: 104613,
                    NG: 104614,
                    NL: 103061,
                    PE: 104615,
                    PL: 104616,
                    PT: 103312,
                    SA: 104617,
                    SE: 103309,
                    ZA: 104618,
                };
                if (p_countries[country]) {
                    var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                    var crypto = require("crypto");
                    try {
                        /*let email = crypto.createHash('md5').update(result.res_data.user.email).digest("hex");*/
                        // let email = crypto.createHash('md5').update('1').digest("hex")
                        let setAccount = { event: "setAccount", account: p_countries[country] };
                        let setEmail = { event: "setEmail", email: "" /*, hash_method: "md5"*/ };
                        let setSiteType = { event: "setSiteType", type: deviceType };
                        let viewBasket = { event: "viewBasket", item: [{ id: "registration", price: "1", quantity: "1" }] };
                        /*console.log('critio-update-viewBasket-before :- ',JSON.stringify([setAccount,setEmail,setSiteType,viewBasket]))*/
                        window.criteo_q.push(setAccount, setEmail, setSiteType, viewBasket);
                        /*console.log('critio-update-viewBasket-after :- ',JSON.stringify([setAccount,setEmail,setSiteType,viewBasket]))*/
                    } catch (e) {
                        console.log(e);
                    }
                }
            },
            trackEvent(eventName){
                switch(eventName){
                    case 'username':
                        this.$trackEvent('FXView+Register+Name');
                    break;
                    case 'password':
                        this.$trackEvent('FXView+Register+Password');
                    break;
                    case 'email':
                        this.$trackEvent('FXView+Register+Email');
                    break;
                    case 'password':
                        this.$trackEvent('FXView+Register+Password');
                    break;
                    case 'Cpassword':
                        this.$trackEvent('FXView+Register+Confirm+Password');
                    break;
                    case 'otp':
                        this.$trackEvent('FXView+OTP+Focus');
                    break;
                } 
            },
            otpSubmitEvent(){
                this.$trackEvent('FXView+OTP+Submit+Success');
            },
            otpPageEvent(){
                this.$trackEvent('FXView+OTP+Pageview');
            },
            loginEvent(){
                this.$trackEvent('FXView+OTP+Login');
            },
            
            
        },
        created() {
            this.$trackEvent('FXView+Register+Pageview')
            const { fullPath } = this.$route;
            this.prevUrl = fullPath;
            this._runGetCountriesList({ globalParams: {}, localParams: { parameter: this, page: "register" } });
            const _that = this;
            this._runGetUserIp({ globalParams: {}, localParams: { parameter: this } });
            
            if (this.$route.query.investing_ref) {
                this.$cookies.set("investing_ref", this.$route.query.investing_ref, "1y", null, this.$env_var.cookieSaveUrl);
            }
            if ("refLink" in this.$route.query && "refRm" in this.$route.query) {
                this.$cookies.set("refLink", this.$route.query.refLink, "4y", null, this.$env_var.cookieSaveUrl);
                this.$cookies.set("refRm", this.$route.query.refRm, "4y", null, this.$env_var.cookieSaveUrl);
                this.$router.replace({ query: null });
            } else if ("refLink" in this.$route.query) {
                let decrpyLinRm = window.atob(this.$route.query.refLink.toString());
                let decrpyLinRm1 = decrpyLinRm.split("||");
                this.admin_id = decrpyLinRm1[0] != undefined ? decrpyLinRm1[0] : "0";
                this.rm_id = decrpyLinRm1[1] != undefined ? decrpyLinRm1[1] : "0";
                const encyptKey = this.$route.query["refLink"];
                this.$cookies.set("IBREFERLINK", encyptKey, null, null, "fxview.com");
                this.IBREFERLINK = encyptKey;
            }
            if (this.$cookies.isKey("IBREFERLINK")) {
                this.IBREFERLINK = this.$cookies.get("IBREFERLINK");
            }
            if ("verify" in this.$route.query) {
                const encyptKey = this.$route.query["verify"];
                let mykey = crypto.createDecipher("aes-128-cbc", "F*V(I)e^E#1108@3");
                let mystr = mykey.update(encyptKey, "hex", "utf8");
                mystr += mykey.final("utf8");
                let infoArray = mystr.split("^");
                if (_that.IBREFERLINK == "") {
                    _that.IBREFERLINK = infoArray[5];
                }
                let input_json = {
                    globalParams: {
                        email: infoArray[3],
                        mobile: infoArray[4],
                        password: infoArray[2],
                        OTP: infoArray[0],
                        ID: infoArray[1],
                        IBREFERLINK: _that.IBREFERLINK,
                    },
                    localParams: { parameter: _that },
                };
                _that._runVerifyLeadOtp(input_json);
            }
        },
        mounted() {
            
            this.onCaptchaVerified()
            const countryList = this.$refs.res_country.$refs.search;    
            countryList.addEventListener('focus', () => {
                this.$trackEvent('FXView+Register+Country'); 
            });
            const _that = this;
            $(document).on("click", function (event) {
                if (!$(event.target).closest(".tabClass").length) {
                    _that.tabActive = "";
                }
            });

            setTimeout(() => {
                try {
                    if (localStorage.getItem("ip_country")) {
                        this.setCritio(localStorage.getItem("ip_country"));
                    } else {
                        /*fetch("https://ipapi.co/country?key=WqrqGPQYxfU6ySEZKqlU8bNDk9BgWVez4Uk3L4auzRyosaOWSs")*/
                        fetch("https://expapi.fxview.com/get/geo")
                            .then((res) => {
                                if (res.ok) {
                                    return res.text();
                                } else {
                                    throw new Error("HTTP Error " + res.status);
                                }
                            })
                            .then((country) => {
                                this.setCritio(country);
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                } catch (error) {
                    console.log(error);
                }
            }, "3000");
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/register.vue